module.exports = __webpack_public_path__ + "media/metronic/_theme/media/bg/bg-2-d84b02f70d8604c9bc492cc07f5e4706.jpg";